import { AuthStatusStage, Navigation } from '@quizzach/components';
import { AuthPage, AuthStatus } from '@quizzach/styles';
import { useTranslation } from 'react-i18next';

export const RegistrationSuccess = () => {
	const { t } = useTranslation();

	return (
		<AuthPage data-id='registration-success-container'>
			<Navigation />

			<AuthStatus>
				<AuthStatusStage
					hand={t('auth.status.confirm.hand')}
					title={t('auth.registrationSuccess.title')}
				/>

				<div className='formcol'>
					<div className='inner' data-id='registration-container'>
						<p>{t('auth.registrationSuccess.info')}</p>
						<p className='mut'>
							{t('auth.registrationSuccess.contactUsBefore')}{' '}
							<a href='mailto:team@quizzach.com'>team@quizzach.com</a>{' '}
							{t('auth.registrationSuccess.contactUsAfter')}
						</p>
					</div>
				</div>
			</AuthStatus>
		</AuthPage>
	);
};
